<template>
  <div class="text-center">
    <v-menu offset-y>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          small
          icon
          color="white"
          dark
          elevation="0"
          v-bind="attrs"
          v-on="on"
        >
          <v-icon>mdi-menu</v-icon></v-btn
        >
      </template>
      <v-list>
        <v-list-item
          v-if="storeDetails && storeDetails.configs.template.url_help"
          :href="storeDetails.configs.template.url_help"
          target="_blank"
        >
          <v-list-item-title>{{ $t("header.help") }}</v-list-item-title>
        </v-list-item>
        <menu-language />
      </v-list>
    </v-menu>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import MenuLanguage from "./MenuLanguage.vue";
export default {
  components: { MenuLanguage },
  data: () => ({
    selectedMenu: null,
    items: [
      { title: "Português", value: "pt" },
      { title: "Español", value: "es" },
      { title: "English", value: "en" },
    ],
  }),
  computed: {
    ...mapGetters(["storeDetails", "selectedLanguage"]),
  },
  mounted() {
    if (this.selectedLanguage === "pt") this.selected = 0;
    else if (this.selectedLanguage === "es") this.selected = 1;
    else this.selected = 2;
  },
  watch: {
    selectedMenu(v) {
      if (this.items[v]?.value) {
        this.$i18n.locale = this.items[v]?.value;
        localStorage.setItem("language", this.items[v]?.value);
        this.$store.commit("SET_SELECTED_LANGUAGE", this.items[v]?.value);
      }
    },
  },
};
</script>
